import React, { useContext } from 'react';
import StudentContext from '../../context/student/studentContext';
import EvaluationContext from '../../context/evaluation/evaluationContext';
import { Link } from "react-router-dom";

const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
}

function MatchFromStudent() {

    const studentContext = useContext(StudentContext);
    const { mentorFromStudent } = studentContext;

    const evaluationContext = useContext(EvaluationContext);
    const { formularios, asignarFormulario/* , evaluacion, guardarEvaluacion */ } = evaluationContext;

    const realizarEvaluacion = (form, studentId, n) => {
        sessionStorage.setItem('evaluated',n);
        const data = {
            form,
            matchedId: studentId
        }
        asignarFormulario(data)
    }   

    const mentor = mentorFromStudent?.length > 0 ? mentorFromStudent[0] : {};
    const { _id, name, last_name, email, laboral_email, career, college, aditional_courses, companies, functions, industry, area } = mentor;

    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    {
                        mentorFromStudent?.length > 0 ? (
                            <div className="card">
                                <div className="card-header border-bottom">
                                    <h3 className="m-0">Mentor asignado: {`${capitalize(name)} ${capitalize(last_name)}`}</h3>
                                </div>
                                <div className="card-body">
                                    <div className="card-text">
                                    
                                        <div className="row">

                                            <div className="col-md-4 col-sm-4 col-xs-12">
                                                <label htmlFor="email">E-mail</label>
                                                <p><i>{email}</i></p>
                                            </div>

                                            <div className="col-md-4 col-sm-4 col-xs-12">
                                                <label htmlFor="laboral_email">E-mail laboral</label>
                                                <p><i>{laboral_email}</i></p>
                                            </div>

                                            <div className="col-md-4 col-sm-4 col-xs-12 text-right">
                                                { formularios?.length > 0 && (
                                                    <div className="btn-group" role="group" aria-label="Basic example">
                                                        { formularios.map((row) => (
                                                            <button type="button" className="btn btn-outline-primary" key={row._id} onClick={() => realizarEvaluacion(row, _id, capitalize(name) + ' ' + capitalize(last_name))}>
                                                                <Link to='/evaluacion' >
                                                                    <i className="material-icons">list</i>
                                                                    <span>Evaluación {row.number}</span>
                                                                </Link>
                                                            </button>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>

                                            <div className="col-md-6 col-sm-6 col-xs-12">
                                                <div className="form-group">
                                                    <h4>Antecedentes académicos</h4>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-sm-6 col-xs-12">
                                                <label htmlFor="career">Carrera</label>
                                                <p><i>{career}</i></p>
                                            </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <label htmlFor="college">Universidad</label>
                                                <p><i>{college}</i></p>
                                            </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <label htmlFor="aditional_courses">Estudios adicionales</label>
                                                <p><i>{aditional_courses}</i></p>
                                            </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <h4>Trayectoria laboral</h4>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-sm-6 col-xs-12">
                                                <label htmlFor="industry">Industria de su interés</label>
                                                <div className="form-group">
                                                    {industry.map((x, i) => (
                                                            <span className="badge bg-light text-dark" key={i} >▪ {x}</span>
                                                        )        
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-sm-6 col-xs-12">
                                                <label htmlFor="area">Áreas</label>
                                                <div className="form-group">
                                                    {area.map((x, i) => (
                                                            <span className="badge bg-light text-dark" key={i} >▪ {x}</span>
                                                        )        
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <label htmlFor="companies">Empresas en las que ha laborado</label>
                                                <p><i>{companies}</i></p>
                                            </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <label htmlFor="functions">Funciones desempeñadas</label>
                                                <p><i>{functions}</i></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="card">
                                <div className="card-header border-bottom">
                                    <h3 className="m-0">Sin Mentor asignado</h3>
                                </div>
                                <div className="card-body">
                                    <div className="card-text">
                                        <div className="row">

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <h4>No cuentas con mentor asignado, por favor comunícate con la Coordinación del Centro de Enlace</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    </div>
                </div>
            </div>
            
            
        </>
    )
}

export default MatchFromStudent
